<div class="modal-header">
    <h4 class="modal-title">Send Order</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <ng-container *ngxPermissionsOnly="'Wolseley'">
        <sf-callout color="info" iconColour="info" icon="question-circle">
            <h5>Did you know?</h5>
            <p>
                You can place orders directly with Wolseley? Click the Wolseley dropdown button to send the order direct
                to the customer, office or work address.
            </p>
        </sf-callout>
    </ng-container>
    <ng-container [formGroup]="form">
        <div class="row">
            <div class="col-12">
                @if (emailTemplates$ | async; as emailTemplates) {
                    <sf-label for="template" label="Select your email template">Select</sf-label>
                    <ng-select
                        id="template"
                        [items]="emailTemplates"
                        bindLabel="name"
                        bindValue="name"
                        class="mb-2"
                        (change)="onEmailTemplateChange($event)"></ng-select>
                }
            </div>
        </div>
        @if (hasSelectedATemplate) {
            <hr />
            <div class="row">
                <div class="col-xl-8">
                    <sf-input label="Email Subject" inputId="subject" formControlName="subject"></sf-input>
                    <sf-input label="Heading" inputId="heading" formControlName="heading"></sf-input>

                    <sf-label for="body" label="Email body to send to supplier"></sf-label>
                    <editor id="body" [required]="true" [init]="tinymceSettings" formControlName="body"> </editor>
                </div>
                <div class="col-xl-4">
                    @if (showDeliveryDateControl) {
                        <div class="mb-3">
                            <sf-label for="deliveryDate" label="Select your delivery date"></sf-label>
                            <div class="input-group">
                                <input
                                    class="form-control"
                                    placeholder="yyyy-mm-dd"
                                    name="dp"
                                    formControlName="deliveryDate"
                                    ngbDatepicker
                                    [minDate]="minDate"
                                    (click)="d.open()"
                                    #d="ngbDatepicker" />
                                <button
                                    class="btn btn-outline-secondary bi bi-calendar3"
                                    (click)="d.toggle()"
                                    type="button"></button>
                            </div>
                            @if (form.controls.deliveryDate.errors) {
                                <div class="invalid-feedback d-block">Delivery date is required</div>
                            }
                        </div>
                    }
                    <sf-input
                        label="Supplier Email Address"
                        inputId="emailAddress"
                        formControlName="emailAddress"></sf-input>
                    @if (supplierEmails$ | async; as supplierEmailsPaged) {
                        <sf-label for="email" label="Select your supplier" [required]="true">Select</sf-label>
                        <sf-list-selector
                            [options]="supplierEmailsPaged.items"
                            (selectionChanged)="onSupplierChange($event)">
                            <ng-template [options]="supplierEmailsPaged.items" let-item>
                                <p class="mb-0">
                                    <b>{{ item.supplierName }}</b
                                    ><br />
                                    {{ item.emailAddress }}
                                </p>
                            </ng-template>
                        </sf-list-selector>
                        <sf-pagination-detail
                            [paginationData]="supplierEmailsPaged"
                            (onPageChange)="onSupplierEmailPageChanged($event)"></sf-pagination-detail>
                    }
                </div>
            </div>
        }
    </ng-container>
</div>
<div class="modal-footer">
    <button sfButton color="danger" (click)="activeModal.close('Close click')">Close</button>
    <button sfButton color="success" (click)="sendTheOrder()" [disabled]="form.invalid">
        Send Order {{ selectedSupplierEmail ? 'to ' + selectedSupplierEmail.supplierName : '' }}
    </button>
</div>
